// Get all sub-targets for a specific plan
export const getSubTargetsByPlanId = async (planId) => {
  try {
    const token = "Bearer " + localStorage.getItem("authToken");
    const response = await fetch(`${process.env.REACT_APP_API_URL}v1/sub-targets/plan/${planId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'accept': 'application/json',
        'Authorization': token,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching sub-targets:', error);
    throw error;
  }
};

// Get sub-targets summary for a plan
export const getSubTargetsSummary = async (planId) => {
  try {
    const token = "Bearer " + localStorage.getItem("authToken");
    const response = await fetch(`${process.env.REACT_APP_API_URL}v1/sub-targets/plan/${planId}/summary`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'accept': 'application/json',
        'Authorization': token,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching sub-targets summary:', error);
    throw error;
  }
};

// Create a new sub-target
export const createSubTarget = async (subTargetData) => {
  try {
    const token = "Bearer " + localStorage.getItem("authToken");
    const response = await fetch(`${process.env.REACT_APP_API_URL}v1/sub-targets`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'accept': 'application/json',
        'Authorization': token,
      },
      body: JSON.stringify(subTargetData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error creating sub-target:', error);
    throw error;
  }
};

// Update a sub-target
export const updateSubTarget = async (subTargetId, updateData) => {
  try {
    const token = "Bearer " + localStorage.getItem("authToken");
    const response = await fetch(`${process.env.REACT_APP_API_URL}v1/sub-targets/${subTargetId}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'accept': 'application/json',
        'Authorization': token,
      },
      body: JSON.stringify(updateData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error updating sub-target:', error);
    throw error;
  }
};

// Update sub-target progress
export const updateSubTargetProgress = async (subTargetId, progress) => {
  try {
    const token = "Bearer " + localStorage.getItem("authToken");
    const response = await fetch(`${process.env.REACT_APP_API_URL}v1/sub-targets/${subTargetId}/progress?progress=${progress}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'accept': 'application/json',
        'Authorization': token,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error updating sub-target progress:', error);
    throw error;
  }
};

// Delete a sub-target
export const deleteSubTarget = async (subTargetId) => {
  try {
    const token = "Bearer " + localStorage.getItem("authToken");
    const response = await fetch(`${process.env.REACT_APP_API_URL}v1/sub-targets/${subTargetId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'accept': 'application/json',
        'Authorization': token,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return true;
  } catch (error) {
    console.error('Error deleting sub-target:', error);
    throw error;
  }
};
